/**
 * 统计相关接口
 * 接口文档 http://47.110.15.13:8020/pages/viewpage.action?pageId=6291626
 * @type {{}}
 */
const statistics = {
  // 3.1 当前用户各项目二维码统计
  getProjectQRCodeOverviewStatistic: '/api/QRCodeAnalyze/GetProjectQRCodeOverviewStatistic',
  // 3.2、当前用户所有项目二维码统计
  getSystemOverviewStatistic: '/api/QRCodeAnalyze/GetSystemOverviewStatistic',
}

Object.freeze(statistics)
export default statistics
